import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { useCallback } from "react";
import { SchemaData, UseCreateProps } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { useNavigate } from "react-router-dom";

export default function useCreate({ onSuccess }: UseCreateProps) {
  const navigate = useNavigate();
  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const { updatedAt, createdAt, ...data } = state?.data;

    const response = await ApiCourseRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: {
        data,
      },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data || !response?.data?.data?.createCourseGroup?.id) {
      throw new Error("Ops. Sem resposta!");
    }

    if (onSuccess) {
      onSuccess(response.data.data);
    } else {
      navigate(`/ecommerce/grupo-de-cursos/${response.data.data.createCourseGroup.id}`);
    }

    return response;
  }, []);

  return {
    handleSave,
  };
}
